var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Button as BaseButton } from 'semantic-ui-react';


var Button = function (props) {
    var option = props.option, selected = props.selected, text = props.text, link = props.link, classNameProp = props.className, children = props.children, _a = props.size, size = _a === void 0 ? 'medium' : _a, baseButtonProps = __rest(props, ["option", "selected", "text", "link", "className", "children", "size"]);
    var classNames = ['pluggy'];
    if (classNameProp) {
        classNames.push(classNameProp);
    }
    if (option) {
        classNames.push('option');
        if (selected) {
            classNames.push('selected');
        }
    }
    if (text) {
        classNames.push('text');
    }
    if (link) {
        classNames.push('link');
    }
    if (size) {
        classNames.push(size);
    }
    var className = classNames.join(' ');
    return (React.createElement(React.Fragment, null,
        React.createElement(BaseButton, __assign({}, baseButtonProps, { className: className }),
            React.createElement("div", { className: 'content' }, children))));
};
export { Button };
